import React, {useState} from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import SpinnerV2 from '../Spinner/Spinner';
import { addBoardMember } from '../../redux/actions/boardMemberActions';
import BoardMemberForm from './BoardMemberForm';
import { useEffect } from 'react';

const NewBoardMember = (props) => {
  const dispatch = useDispatch();
  const boardMembers = useSelector(state => state.boardMembers);
  const [isAdding, setIsAdding] = useState(false);
  const history = useHistory();
  
  const boardMember = {
    id: undefined,
    user_id: undefined,
    role_type: "",
    term_end_date: new Date(),
    name: ''
  }

  useEffect(() => {
    if (isAdding && boardMembers.updating === false) {
      setIsAdding(false);
      history.replace(`/documents`)
    }
  }, [isAdding])

  const onAddBoardMember = (boardMember) => {
    setIsAdding(true);
    dispatch(addBoardMember(boardMember));
  }
  if (boardMembers.updating) {
    return <SpinnerV2 title="Adding new board member..." />
  }

  return (
    <BoardMemberForm 
      title="Add New Board Member" 
      edit={false} 
      boardMember={boardMember} 
      onSubmit={onAddBoardMember}
      onCancel={() => {history.goBack()}}
    />
  );
}
export default NewBoardMember;
